import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CzechiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14574'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14574)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V7H0V14Z'
					fill='#E8252A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L9.52381 7L0 14V0Z'
					fill='#17579E'
				/>
			</g>
		</svg>
	);
};

export default CzechiaFlagIcon;
